// Some brands look up profiles with a prefixed user, while others use the bare user.
const lookupPrefixes = {
  TENGO: 'TENGO',
  COLOCA: 'COLOCA',
  BITPPI: 'BITPPI',
  EZYTRANSFER: 'EZYTRANSFER',
  EZY_TRANSFER: 'EZYTRANSFER',
};

export const getProfileLookupUser = (user, brand) => {
  const value = String(user || '').trim();
  const normalizedBrand = String(brand || '').toUpperCase();
  const prefix = lookupPrefixes[normalizedBrand];
  const match = value.match(/^([A-Za-z_]+)-(.+)$/);
  const incomingPrefix = match?.[1].toUpperCase();
  const matchesBrand = incomingPrefix === normalizedBrand ||
    (prefix && lookupPrefixes[incomingPrefix] === prefix);

  // Keep a different brand prefix intact so it cannot be silently reassigned.
  if (match && !matchesBrand && lookupPrefixes[incomingPrefix]) {
    return value;
  }

  const bareUser = matchesBrand ? match[2] : value;
  return prefix ? `${prefix}-${bareUser}` : bareUser;
};
